<div class="row justify-content-center">
  <div class="col-lg-8 content-area">
    <div class="page-card">
      <div id="introduction">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'introduction'">
          Introduction
        </h2>

        <p class="f-s-14">
          Andica Charity Accounts Software is designed specifically for charitable organisations to simplify the preparation of year end financial reports both audited and unaudited in full compliance with FRS 102, the Charities SORP, the Charities Act 2011, and the Companies Act 2006.
        </p>

        <p class="f-s-14">
          The software supports regulatory compliance with the Charity Commission (England and Wales) ensuring that financial statements meet all statutory and reporting standards.
        </p>

        <p class="f-s-14">
          Its core purpose is to streamline the production and submission of final accounts by enabling trial balance imports, automating financial statement generation, and facilitating direct submissions to the Charity Commission and Companies House.
        </p>
      </div>

      <div id="features">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'features'">
          Features
        </h2>

        <p class="f-s-14">
          Key features of Andica Charity Software Includes:
        </p>

        <ol class="feature-list">

          <li>
            <strong>Charities</strong> -
            Creating, editing, deleting and switching between charities.

            <ul class="sub-feature-list">
              <li>Basic Information</li>
              <li>Trial Balance</li>
              <li>Statement of Financial Activities / Receipts & Payments</li>
              <li>Balance Sheet / Statement of Assets & Liabilities</li>
              <li>Notes of Accounts</li>
              <li>Trustee's Reports</li>
              <li>Independent Examiner's Report / Auditor Report</li>
              <li>Final Accounts</li>
              <li>Submissions</li>
            </ul>
          </li>

          <li>
            <strong>Submission History</strong>
          </li>

          <li>
            <strong>Reports</strong>

            <ul class="sub-feature-list">
              <li>Charity Report</li>
              <li>Trustee's Report</li>
              <li>Trial Balance Report</li>
              <li>Chart of Accounts Report</li>
            </ul>
          </li>

          <li>
            <strong>Settings</strong>

            <ul class="sub-feature-list">
              <li>My Account</li>
              <li>Email Configuration</li>
              <li>Preference</li>
              <li>User Management</li>
            </ul>
          </li>

        </ol>
      </div>

    </div>
  </div>

  <!-- Right Sidebar -->
  <div class="col-lg-3">
    <div class="on-page-sidebar">

      <p class="sidebar-title">On this page</p>

    

          <ul class="submenu-level-2">

            <li [class.active]="selectedSection === 'introduction'"
                (click)="changeSection('introduction')">

              Introduction

            </li>

            <li [class.active]="selectedSection === 'features'"
                (click)="changeSection('features')">

              Features

            </li>

          </ul>

        

    </div>
  </div>


</div>
